import React, { useContext, useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { TranslatorContext } from "../../context/Translator";
import { getAlumnosGira, getApoderdosGiras } from "../../api/giras.ts";

export default function ResumenPasajerosComponent({ gira }) {
    const { t } = useContext(TranslatorContext);
    const [alumnos, setAlumnos] = useState([]);
    const [apoderados, setApoderados] = useState([]);
    const [resumen, setResumen] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (gira?.gir_id) {
            cargarDatos();
        }
    }, [gira]);

    const cargarDatos = async () => {
        try {
            setLoading(true);
            const resAlumnos = await getAlumnosGira(gira.gir_id);
            const resApoderados = await getApoderdosGiras(gira.gir_id);
            
            setAlumnos(resAlumnos || []);
            setApoderados(resApoderados || []);
            
            // Calcular resumen
            calcularResumen(resAlumnos || [], resApoderados || []);
        } catch (error) {
            console.error('Error cargando datos:', error);
        } finally {
            setLoading(false);
        }
    };

    const calcularEdad = (fechaNacimiento) => {
        if (!fechaNacimiento) return null;
        const hoy = new Date();
        const fecha = new Date(fechaNacimiento);
        let edad = hoy.getFullYear() - fecha.getFullYear();
        const mesActual = hoy.getMonth();
        const mesNacimiento = fecha.getMonth();
        
        if (mesActual < mesNacimiento || (mesActual === mesNacimiento && hoy.getDate() < fecha.getDate())) {
            edad--;
        }
        return edad;
    };

    const esCumpleanios = (fechaNacimiento, fechaViaje) => {
        if (!fechaNacimiento || !fechaViaje) return false;
        
        const fecha = new Date(fechaNacimiento);
        const viaje = new Date(fechaViaje);
        
        return fecha.getMonth() === viaje.getMonth() && 
               fecha.getDate() === viaje.getDate();
    };

    const tienePadecimiento = (enfermedad, tratamiento) => {
        const esVacio = (valor) => {
            if (!valor) return true;
            const strValor = String(valor).trim().toUpperCase();
            return strValor === '' || strValor === 'NO' || strValor === 'NULL';
        };
        
        return !esVacio(enfermedad) || !esVacio(tratamiento);
    };

    const calcularResumen = (alumnosData, apoderadosData) => {
        const fechaViaje = gira?.gir_fecha_viaje ? new Date(gira.gir_fecha_viaje) : null;
        
        // Contadores
        let totalPasajeros = 0;
        let cumpleanios = 0;
        let conDiagnostico = 0;
        let alumnosM = 0;
        let alumnosF = 0;
        let adultosM = 0;
        let adultosF = 0;
        
        const restricciones = {
            sinRestriccion: 0,
            vegetariano: 0,
            vegano: 0,
            celiaco: 0,
            intolerante: 0
        };

        // Procesar alumnos
        console.log('Procesando alumnos:', alumnosData);
        alumnosData.forEach(alumno => {
            if (alumno && alumno.alu_nombres) {
                totalPasajeros++;
                
                // Cumpleaños
                if (fechaViaje && esCumpleanios(alumno.alu_fnacimiento, gira?.gir_fecha_viaje)) {
                    cumpleanios++;
                }
                
                // Diagnósticos
                if (tienePadecimiento(alumno.enfermedad, alumno.tratamiento)) {
                    conDiagnostico++;
                }
                 const tipoPasajero = (alumno.calidad || '').toLowerCase().trim();
                
                // Sexo
                const esAlumno = tipoPasajero.includes('alumno');
                const esAdulto = tipoPasajero.includes('adulto');
                if(esAlumno){
                     const sexo = alumno.sexo?.toLowerCase() || alumno.genero?.toLowerCase() || '';
                    if (sexo === 'masculino' || sexo === 'm') {
                        alumnosM++;
                    } else if (sexo === 'femenino' || sexo === 'f') {
                        alumnosF++;
                    }
                }

                 if(esAdulto){
                     const sexo = alumno.sexo?.toLowerCase() || alumno.genero?.toLowerCase() || '';
                    if (sexo === 'masculino' || sexo === 'm') {
                        adultosM++;
                    } else if (sexo === 'femenino' || sexo === 'f') {
                        adultosF++;
                    }
                }
               
                
                // Restricciones alimenticias
                const idAlimentacion = alumno.idalimentacion;
                if (idAlimentacion) {
                    if (idAlimentacion === 1) {
                        restricciones.sinRestriccion++;
                    } else if (idAlimentacion === 2) {
                        restricciones.vegetariano++;
                    } else if (idAlimentacion === 3) {
                        restricciones.vegano++;
                    } else if (idAlimentacion === 4) {
                        restricciones.intolerante++;
                    } else if (idAlimentacion === 5) {
                        restricciones.celiaco++;
                    }
                }
            }
        });

     
        setResumen({
            totalPasajeros,
            cumpleanios,
            conDiagnostico,
            alumnosM,
            alumnosF,
            adultosM,
            adultosF,
            restricciones
        });
    };

    if (loading || !resumen) {
        return (
            <Row className="mb-4">
                <Col xl={12}>
                    <div className="mc-card">
                        <div style={{ textAlign: 'center', padding: '30px' }}>
                            <p>Cargando datos de pasajeros...</p>
                        </div>
                    </div>
                </Col>
            </Row>
        );
    }

    return (
        <Row className="mb-4">
            <Col xl={12}>
                <div className="mc-card">
                    <div className="mc-card-head" style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '15px', marginBottom: '20px' }}>
                        <h5 style={{ margin: '0', fontWeight: '600' }}>📊 Resumen de Pasajeros</h5>
                    </div>
                    
                    <div className="mc-table-responsive">
                        <table className="mc-table product">
                            <thead className="mc-table-head primary">
                                <tr>
                                    <th colSpan="2" style={{ textAlign: 'center' }}>Total de Pasajeros</th>
                                </tr>
                            </thead>
                            <tbody className="mc-table-body even">
                                <tr>
                                    <td style={{ fontWeight: '500' }}>Total General</td>
                                    <td style={{ textAlign: 'center', fontWeight: '700', fontSize: '1.1em', color: '#2196F3' }}>
                                        {resumen.totalPasajeros}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div style={{ marginTop: '30px' }} className="mc-table-responsive">
                        <table className="mc-table product">
                            <thead className="mc-table-head primary">
                                <tr>
                                    <th colSpan="2" style={{ textAlign: 'center' }}>Información por Tipo de Pasajero</th>
                                </tr>
                            </thead>
                            <tbody className="mc-table-body even">
                                <tr>
                                    <td style={{ fontWeight: '500' }}>Alumnos Masculinos</td>
                                    <td style={{ textAlign: 'center', fontWeight: '600' }}>{resumen.alumnosM}</td>
                                </tr>
                                <tr>
                                    <td style={{ fontWeight: '500' }}>Alumnos Femeninos</td>
                                    <td style={{ textAlign: 'center', fontWeight: '600' }}>{resumen.alumnosF}</td>
                                </tr>
                                <tr>
                                    <td style={{ fontWeight: '500' }}>Adultos Masculinos</td>
                                    <td style={{ textAlign: 'center', fontWeight: '600' }}>{resumen.adultosM}</td>
                                </tr>
                                <tr>
                                    <td style={{ fontWeight: '500' }}>Adultos Femeninos</td>
                                    <td style={{ textAlign: 'center', fontWeight: '600' }}>{resumen.adultosF}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div style={{ marginTop: '30px' }} className="mc-table-responsive">
                        <table className="mc-table product">
                            <thead className="mc-table-head primary">
                                <tr>
                                    <th colSpan="2" style={{ textAlign: 'center' }}>Información Médica y Especial</th>
                                </tr>
                            </thead>
                            <tbody className="mc-table-body even">
                                <tr>
                                    <td style={{ fontWeight: '500' }}>Cumpleaños en Fecha del Viaje</td>
                                    <td style={{ textAlign: 'center', fontWeight: '600', color: '#FF9800' }}>{resumen.cumpleanios}</td>
                                </tr>
                                <tr>
                                    <td style={{ fontWeight: '500' }}>Con Diagnóstico Médico</td>
                                    <td style={{ textAlign: 'center', fontWeight: '600', color: '#F44336' }}>{resumen.conDiagnostico}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div style={{ marginTop: '30px' }} className="mc-table-responsive">
                        <table className="mc-table product">
                            <thead className="mc-table-head primary">
                                <tr>
                                    <th colSpan="2" style={{ textAlign: 'center' }}>Restricciones Alimenticias</th>
                                </tr>
                            </thead>
                            <tbody className="mc-table-body even">
                                <tr>
                                    <td style={{ fontWeight: '500' }}>Sin Restricción</td>
                                    <td style={{ textAlign: 'center', fontWeight: '600' }}>{resumen.restricciones.sinRestriccion}</td>
                                </tr>
                                <tr>
                                    <td style={{ fontWeight: '500' }}>Vegetariano</td>
                                    <td style={{ textAlign: 'center', fontWeight: '600' }}>{resumen.restricciones.vegetariano}</td>
                                </tr>
                                <tr>
                                    <td style={{ fontWeight: '500' }}>Vegano</td>
                                    <td style={{ textAlign: 'center', fontWeight: '600' }}>{resumen.restricciones.vegano}</td>
                                </tr>
                                <tr>
                                    <td style={{ fontWeight: '500' }}>Celíaco</td>
                                    <td style={{ textAlign: 'center', fontWeight: '600' }}>{resumen.restricciones.celiaco}</td>
                                </tr>
                                <tr>
                                    <td style={{ fontWeight: '500' }}>Intolerante a la Lactosa</td>
                                    <td style={{ textAlign: 'center', fontWeight: '600' }}>{resumen.restricciones.intolerante}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Col>
        </Row>
    );
}
